<template>
    <section class="content">
        <div class="container-fluid">
            <div class="card">
                <div class="fn-header">
                    การจัดการบัญชีธนาคาร
                </div>

                <div class="row" style="margin-top: 15px;">
                    <div class="col-md-2">
                    </div>

                    <div class="col-md-8" style="border: 1px solid #ccc;padding:25px 5px">
                        <div class="bank-header">บัญชีธนาคาร</div>
                        <div>
                            <i class="material-icons edit-icon" @click="edit('bank')">mode_edit</i>
                        </div>
                        <div>
                            <img :src="bank.image" alt="บัญชีธนาคาร" style="width: 50%;" v-if="bank.image">
                        </div>
                        <div style="display: flex; align-items: center; justify-content: center; margin-top: 15px;">
                            <span style="font-weight: bold">ชื่อธนาคาร:
                                <span style="color: #466aa7">{{ bank.bank_name }}</span>

                            </span>

                        </div>
                        <div style="display: flex; align-items: center; justify-content: center; margin-top: 15px;">
                            <span style="font-weight: bold">ชื่อบัญชี:
                                <span style="color: #466aa7">{{ bank.bank_account }}</span>

                            </span>

                        </div>
                        <div style="display: flex; align-items: center; justify-content: center; margin-top: 15px;">
                            <span style="font-weight: bold">เลขที่บัญชี:
                                <span style="color: #466aa7">{{ bank.bank_number}}</span>

                            </span>

                        </div>

                    </div>

                    <div class="col-md-2"></div>

                </div>

                <!--QR-->
                <div class="row" style="margin-top: 15px;">
                    <div class="col-md-2">
                    </div>

                    <div class="col-md-8" style="border: 1px solid #ccc;padding:25px 5px">
                        <div class="bank-header">บัญชีธนาคาร</div>
                        <div>
                            <i class="material-icons edit-icon" @click="edit('qr')">mode_edit</i>
                        </div>
                        <div>
                            <img :src="qr.image" alt="บัญชีธนาคาร" style="width: 50%;" v-if="qr.image">
                        </div>
                        <div style="display: flex; align-items: center; justify-content: center; margin-top: 15px;">
                            <span style="font-weight: bold">ชื่อธนาคาร:
                                <span style="color: #466aa7">{{ qr.bank_name != null ? qr.bank_name : "" }}</span>

                            </span>

                        </div>
                        <div style="display: flex; align-items: center; justify-content: center; margin-top: 15px;">
                            <span style="font-weight: bold">ชื่อบัญชี:
                                <span style="color: #466aa7">{{ qr.bank_account != null ? qr.bank_account : "" }}</span>

                            </span>

                        </div>
                        <div style="display: flex; align-items: center; justify-content: center; margin-top: 15px;">
                            <span style="font-weight: bold">เลขที่บัญชี:
                                <span style="color: #466aa7">{{ qr.bank_number != null ? qr.bank_number : "" }}</span>

                            </span>

                        </div>

                    </div>

                    <div class="col-md-2"></div>

                </div>

                <div class="row" style="margin-top: 25px;">
                    <div class="col-md-2">
                    </div>

                    <div class="col-md-8" style="border: 1px solid #ccc;padding:25px 5px">
                        <div class="bank-header">ทรูวอลเล็ต</div>
                        <div>
                            <i class="material-icons edit-icon" @click="edit('wallet')">mode_edit</i>
                        </div>
                        <div>
                            <img :src="wallet.image" alt="วอลเล็ต" style="width: 50%;" v-if="wallet.image">
                        </div>
                        <div style="display: flex; align-items: center; justify-content: center; margin-top: 15px;">
                            <span style="font-weight: bold">ชื่อบัญชี:
                                <span style="color: #466aa7">{{ wallet.bank_account ? wallet.bank_account : "" }}</span>

                            </span>

                        </div>
                        <div style="display: flex; align-items: center; justify-content: center; margin-top: 15px;">
                            <span style="font-weight: bold">หมายเลขทรูมันนี่ วอลเลท:
                                <span style="color: #466aa7">{{ wallet.bank_number ? wallet.bank_number : "" }}</span>

                            </span>

                        </div>

                        <div style="display: flex; align-items: center; justify-content: center; margin-top: 15px;">
                            <span style="font-weight: bold">ค่าธรรมเนียม:
                                <span style="color: #466aa7">{{ wallet.fee  ? wallet.fee : "" }}</span>%

                            </span>

                        </div>

                        <div style="display: flex; align-items: center; justify-content: center; margin-top: 15px;">
                            <span style="font-weight: bold">หักไม่เกิน:
                                <span style="color: #466aa7">{{ wallet.deduct  ? wallet.deduct : "" }}</span> บาท

                            </span>

                        </div>



                    </div>

                    <div class="col-md-2"></div>

                </div>
                <div style="height: 60px;">

                </div>

            </div>
        </div>
        <div class="modal fade" id="image-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="padding:10px">

                        <span style="color: #466aa7;font-size: 15px;font-weight: bold;">แก้ไข {{ editText }}</span>
                    </div>
                </div>
                <div class="modal-body" style="background:white;min-height: 0;">

                    <div class="row" style="margin-top:20px">

                        <div class="col-sm-12" style="text-align: center;">
                            <div style="margin-top: 15px;" v-if="image.image">
                                <img :src="image.image" class="img-box" alt="i-game" />
                                <div style="margin-top: 10px;">
                                    <i class="material-icons del-image-icon" @click="deleteImage()">clear</i>
                                </div>
                            </div>
                            <div v-else>
                                <button class="file-upload-btn" type="button"
                                    @click="uploadClick()">อัพโหลดรูปภาพ</button>
                                <input class="file-upload-input" type='file' ref="uploadFile"
                                    @change="handleFilesUpload(this);" accept="image/*" />
                            </div>
                        </div>

                    </div>
                    <div class="row" style="margin-top:20px" v-if="image.type == 'bank' || image.type == 'qr'">
                        <div class="col-md-2">
                            ชื่อธนาคาร:
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" placeholder="ชื่อธนาคาร" v-model="image.bank_name">
                        </div>

                    </div>
                    <div class="row" style="margin-top:20px">
                        <div class="col-md-2">
                            ชื่อบัญชี:
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" placeholder="ชื่อบัญชี"
                                v-model="image.bank_account">
                        </div>

                    </div>
                    <div class="row" style="margin-top:20px">
                        <div class="col-md-2">
                            เลขที่บัญชี:
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" placeholder="เลขที่บัญชี"
                                v-model="image.bank_number">
                        </div>

                    </div>
                    <div class="row" style="margin-top:20px" v-if="image.type == 'wallet'">
                        <div class="col-md-2">
                            ค่าธรรมเนียม (%):
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" placeholder="ค่าธรรมเนียม" v-model="image.fee">
                        </div>

                    </div>

                    <div class="row" style="margin-top:20px" v-if="image.type == 'wallet'">
                        <div class="col-md-2">
                            หักไม่เกิน (บาท):
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="form-control" placeholder="หักไม่เกิน" v-model="image.deduct">
                        </div>

                    </div>


                </div>
                <div class="modal-footer" style="background:white">
                    <button type="button" class="btn btn-primary waves-effect" style="width: 150px;"
                        @click="handleSave()">บันทึก</button>
                    <button type="button" class="btn btn-default waves-effect" style="width: 150px;"
                        data-dismiss="modal">ปิด</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ImageService from '../../service/ImageService'
import alertBox from '../../classes/alertBox'
import Paginate from 'vuejs-paginate'

export default {
    name: "BankAccountManage",
    components: {
        Paginate
    },
    data() {
        return {
            bank: {},
            qr:{},
            wallet: {},
            image: {},
            editText: "",
            file: null,
            loading: false,
        }
    },
    async created() {
        await this.getBanks()
    },
    mounted() {

    },
    methods: {
        async getBanks() {
            let response = await ImageService.get("bank,qr,wallet")
            console.log(response)
            if (response.status) {
                this.bank = response.result.find(x => x.type == "bank") || {}
                this.wallet = response.result.find(x => x.type == "wallet") || {}
                this.qr = response.result.find(x => x.type == "qr") || {}
            }
        },
        edit(type) {
            if (type == "bank") {
                this.image = { ...this.bank }
                this.editText = "บัญชีธนาคาร"
            }
            if (type == "qr") {
                this.image = { ...this.qr }
                this.editText = "วอลเล็ต"
            }
            if (type == "wallet") {
                this.image = { ...this.wallet }
                this.editText = "วอลเล็ต"
            }

            $('#image-modal').modal('show')

        },
        async handleSave() {
            if (!this.validate()) {
                return false
            }

            await this.update()


            $('#image-modal').modal('hide')
        },
        validate() {
            // if (!this.file && !this.image.image) {
            //     alertBox.error("กรุณาเลือกภาพ")
            //     return false
            // }

            return true
        },
        async update() {
            try {
                console.log(this.image)
                let formData = new FormData();
                formData.append('id', this.image.id);
                formData.append('deduct', this.image.deduct);
                 formData.append('fee', this.image.fee);
                formData.append('bank_name', this.image.bank_name);
                formData.append('bank_account', this.image.bank_account);
                formData.append('bank_number', this.image.bank_number);
                formData.append('image', this.image.image);
                formData.delete('file');
                if (this.file) {
                    formData.append('file', this.file);
                }

                let response = await ImageService.update(formData)

                if (response.status) {
                    alertBox.success('save success')
                    this.getBanks()
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }
            catch (error) {
                alertBox.error("Error, " + error)
            }
        },
        uploadClick() {
            this.$refs.uploadFile.click()
        },
        handleFilesUpload() {
            let uploadedFiles = this.$refs.uploadFile.files;
            this.image.image = URL.createObjectURL(uploadedFiles[0])
            this.file = uploadedFiles[0]
            this.$refs.uploadFile.value = ""
        },
        async deleteImage() {
            const result = await alertBox.confirm('Are you sure to delete?')

            if (result) {
                this.image.image = ""
            }

        },

    }
}
</script>

<style scoped>
.diamon-text {
    position: absolute;
    width: 140px;
    cursor: pointer;
    text-align: left;
    margin-top: -15px;
    margin-left: 2px;
    background: white;
    z-index: 10;
    padding: 2px 5px;
    border-radius: 5px;
}

.clear-img {
    cursor: pointer;
    color: red;
    font-size: 16px;
    vertical-align: middle;
}

.img-box {
    cursor: zoom-in;
    max-height: 160px;
}

.file-upload {
    background-color: #ffffff;
    width: 600px;
    margin: 0 auto;
    padding: 20px;
}

.file-upload-btn {
    width: 100%;
    color: #2196f3;
    background: #fff;
    border: 1px dashed #2196f3;
    padding: 10px;
    border-radius: 4px;
    /* border-bottom: 4px solid #15824B; */
    transition: all .2s ease;
    outline: none;
    text-transform: uppercase;
    font-weight: 700;
}

.file-upload-btn:hover {
    background: #2196f3;
    color: #ffffff;
    transition: all .2s ease;
    cursor: pointer;
}

.file-upload-btn:active {
    border: 0;
    transition: all .2s ease;
}

.file-upload {
    background-color: #ffffff;
    width: 600px;
    margin: 0 auto;
    padding: 20px;
}

.file-upload-content {
    display: none;
    text-align: center;
}

.file-upload-input {
    position: absolute;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    outline: none;
    opacity: 0;
    cursor: pointer;
}

.image-title-wrap {
    padding: 0 15px 15px 15px;
    color: #222;
}

.file-upload-image {
    max-height: 200px;
    max-width: 200px;
    margin: auto;
    padding: 20px;
}

.del-image-icon {
    color: red;
    cursor: pointer;
    font-size: 21px;
}

.edit-icon {
    position: absolute;
    right: 25px;
    font-size: 17px;
    border: 1px solid;
    cursor: pointer;
}

.bank-header {
    position: absolute;
    top: -15px;
    left: 25px;
    font-size: 18px;
    padding: 5px;
    background: white;
}
</style>


// WEBPACK FOOTER //
// src/components/Manage/BankAccount.vue